export default __webpack_public_path__ + "static/media/roadmapBgMb.ee779491.png";